import {Typography} from "@mui/material"
import _ from "lodash"
import Mustache from "mustache"
import React from "react"

const valueProps = ["valueColor", "valueTextAlignment", "valueFontWeight", "valueFontSize", "valueLineHeight"]

const collectValuePropsFromWidget = (widget) => _(widget)
    .pickBy((value, key) => valueProps.includes(key))
    .mapKeys((value, key) => _.camelCase(key.replace("value", "")))
    .value()

const BuildTextWithStyledValues = ({widget, data, textProps}) => {
    const {text} = widget
    const valueProps = collectValuePropsFromWidget(widget)
    const tokens = Mustache.parse(text)

    return (
        <Typography
            {...textProps}
        >
            {tokens.map((token, index) => {
                const [type, value] = token

                if (type === "name") {
                    const variableValue = value.split(".").reduce((obj, key) => obj?.[key], data)

                    return (
                        <Typography
                            key={index}
                            component="span"
                            {...valueProps}
                            sx={{display: "inline", ...valueProps.sx}}
                        >
                            {variableValue ?? `{{${value}}}`}
                        </Typography>
                    )
                }
                return <span key={index}>{value}</span>
            })}
        </Typography>
    )
}

export default BuildTextWithStyledValues